import React from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import CompactSection from 'src/presentation/components/pages/integrations/editorComponents/CompactSection';
import { Row } from 'src/presentation/components/forms/Layout';
import { WrappedField } from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';

function renderQualtricsConfiguration(onChange: (attr: string) => ChangeHandler): JSX.Element {
  return (
    <>
      <CompactSection
        description={`The Gladly-Qualtrics integration allows activity in Gladly to be sent to 
        Qualtrics when a conversation is closed. This can then be used to trigger customer 
        surveys inside Qualtrics.`}
      >
        <Row>
          <WrappedField
            attr="name"
            label="Name"
            placeholder="App Name"
            description="This is the name that will be displayed throughout Gladly"
            data-aid="qualtrics-integration-name"
            autoFocus={true}
            onChange={onChange('name')}
          />
        </Row>
        <Row>
          <WrappedField
            attr="connectionSettings.qualtricsWebhookUrl"
            placeholder="e.g. https://ca1.qualtrics.com/inbound-event/v1/events/JSON/triggers?..."
            label="Qualtrics JSON event endpoint"
            description="This field is used to determine where in Qualtrics to send data"
            data-aid="qualtrics-webhook-url"
            onChange={onChange('connectionSettings.qualtricsWebhookUrl')}
          />
        </Row>
        <Row>
          <WrappedField
            attr="connectionSettings.publicKey"
            label="Qualtrics Token"
            description="This field is used to authentificate Qualtrics requests"
            data-aid="qualtrics-public-key"
            onChange={onChange('connectionSettings.publicKey')}
          />
        </Row>
      </CompactSection>
    </>
  );
}

export default renderQualtricsConfiguration;
